<div class="py2 md-px4 sm-px2" [id]="'reference-editor-' + cslData()">
  <sfo-csl-schema-selector
    [cslSchemas]="cslSchemas()"
    [patchForm]="cslData()"
    (formValue)="onFormValueChange($event)"
  ></sfo-csl-schema-selector>
</div>
